<template>
  <b-list-group-item style="text-align:left; border:0px; padding:0.5vw 5vw">
    <b-card nobody style="padding:3px">
        <b-row no-gutters>
            <b-col md="3" style="padding: 1% 0 1%">
                <b-card-img :src="data.image" alt="Image" class="rounded-0" style="width:95%"></b-card-img>
            </b-col>
            <b-col md="9">
                <b-card-body  style="padding:5px">
                    <b-card-text v-html="data.title"  style="margin-bottom:0.5em; font-size: 18px; font-weight:bold"/>
                    <b-card-text v-html="data.authors"  style="margin:0; font-size: 16px"/>
                    <b-card-text v-html="data.booktitle" style="margin-top:0.3em; margin-bottom:0.5em;font-size: 16px" />
                    <b-button v-for="i in Object.keys(data.links)" target="_blank" :key="'link_'+i" :href='data.links[i]' style="margin-right: 10px; padding:3px; font-size:12px; border-color:" variant="outline-secondary">
                        {{i}}
                    </b-button>
                </b-card-body>
            </b-col>
        </b-row>
    </b-card>
  </b-list-group-item>
</template>

<script>
import { BListGroupItem, BCard, BButton, BCardHeader,
    BCardBody, BCardImg, BRow, BCol, BCardText } from "bootstrap-vue"


export default {
  name: 'Publication',
  props: ["data"],
  components:{
    BListGroupItem,
    BCard,
    BButton,
    BCardHeader,
    BCardBody,
    BCardImg,
    BRow, 
    BCol, 
    BCardText
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card-body{
    padding:5px
}
</style>
